export default "__VITE_ASSET__DkKS35Na__"